import { suppliesPromotionIdFormat } from "@redotech/redo-marketplace-id";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import * as z from "zod";

const EligiblePromotionProductSchema = z.object({
  id: productIdFormat.schema,
  productFamilyId: productFamilyIdFormat.schema,
  title: z.string(),
  imageUrl: z.string().nullish(),
});

const ActiveSuppliesPromotionSchema_ = z.object({
  id: suppliesPromotionIdFormat.schema,
  thresholdAmount: z.number(),
  storefrontMessage: z.string().nullish(),
  firstTimeCustomersOnly: z.boolean(),
  eligibleProducts: z.array(EligiblePromotionProductSchema),
});
export const ActiveSuppliesPromotionSchema: z.ZodType<ActiveSuppliesPromotion> =
  ActiveSuppliesPromotionSchema_;
export interface ActiveSuppliesPromotion extends z.infer<
  typeof ActiveSuppliesPromotionSchema_
> {}

export const getActiveSuppliesPromotion = {
  name: "getActiveSuppliesPromotion" as const,
  input: z.object({}),
  output: z.object({ promotion: ActiveSuppliesPromotionSchema.nullish() }),
};
